
export default {

    banks(state){
        return state.banks
    },

    bank(state){
        return state.bank
    }
}